// ─────────────────────────────────────────────────────────────
// ZIFEK — Version de la plateforme
// La version est incrémentée AUTOMATIQUEMENT à chaque push GitHub
// (workflow .github/workflows/version-bump.yml → scripts/bump-version.mjs) :
//   v1.0 → v1.1 → … → v1.9 → v2.0 → v2.1 …
// Le script met à jour le fichier VERSION ET la constante ci-dessous,
// affichée dans les tableaux de bord de tous les utilisateurs.
// L'identifiant de build est injecté au moment de la construction.
// ─────────────────────────────────────────────────────────────

declare const __READDY_VERSION_ID__: string;

/** Version majeure de la plateforme Zifek. */
export const ZIFEK_VERSION = '3.2.0';

/** Identifiant de build injecté par l'environnement (peut être vide). */
export function getBuildId(): string {
  try {
    return typeof __READDY_VERSION_ID__ !== 'undefined' && __READDY_VERSION_ID__
      ? String(__READDY_VERSION_ID__)
      : '';
  } catch {
    return '';
  }
}

/** Libellé court de version, ex : « Zifek v3.1.0 ». */
export function getVersionLabel(): string {
  return `Zifek v${ZIFEK_VERSION}`;
}

/**
 * Libellé de build affiché à côté de la version, ex : « b-8f3a91 ».
 * Retombe sur la date du jour si aucun identifiant n'est injecté.
 */
export function getBuildLabel(): string {
  const id = getBuildId();
  if (!id) {
    const d = new Date();
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
  }
  return `b-${id.slice(-6)}`;
}

/** Détails complets (utilisés dans l'infobulle). */
export function getFullVersionInfo(): string {
  const id = getBuildId();
  return `${getVersionLabel()} · ${getBuildLabel()}${id ? ` (build ${id})` : ''}`;
}